// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_WlDuC {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 14px;
}

@media screen and (max-width: 1617px) {
  .grid_WlDuC {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 909px) {
  .grid_WlDuC {
    grid-template-columns: 1fr;
  }
}

.card_N4wy7 {
  flex: 1;
  min-width: 360px !important;
  width: 100% !important;
}

.cardAreaGood_RkfN8 {
  background-color: #029e2e !important;
}

.cardAreaGood_RkfN8 * {
  color: white !important;
}

.cardAreaBad_HxE87 {
  background-color: #DB253D !important;
}

.cardAreaBad_HxE87 * {
  color: white !important;
}

.detailBox_iqCKa * {
  color: #394756 !important;
}

.paceCardDetailContentGood_l9ojg {
  color: #029e2e !important;
}

.paceCardDetailContentBad_L4CrP {
  color: #DB253D !important;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/cycleTimeMonitoring/components/PaceOverviewCards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 14px;\n}\n\n@media screen and (max-width: 1617px) {\n  .grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media screen and (max-width: 909px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.card {\n  flex: 1;\n  min-width: 360px !important;\n  width: 100% !important;\n}\n\n.cardAreaGood {\n  background-color: #029e2e !important;\n}\n\n.cardAreaGood * {\n  color: white !important;\n}\n\n.cardAreaBad {\n  background-color: #DB253D !important;\n}\n\n.cardAreaBad * {\n  color: white !important;\n}\n\n.detailBox * {\n  color: #394756 !important;\n}\n\n.paceCardDetailContentGood {\n  color: #029e2e !important;\n}\n\n.paceCardDetailContentBad {\n  color: #DB253D !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_WlDuC`,
	"card": `card_N4wy7`,
	"cardAreaGood": `cardAreaGood_RkfN8`,
	"cardAreaBad": `cardAreaBad_HxE87`,
	"detailBox": `detailBox_iqCKa`,
	"paceCardDetailContentGood": `paceCardDetailContentGood_l9ojg`,
	"paceCardDetailContentBad": `paceCardDetailContentBad_L4CrP`
};
export default ___CSS_LOADER_EXPORT___;
